import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/slide_table'
import SlideService from '../../network/services/slide'
import { serialize } from '../../network/request'
import SlideTable from './SlideTable'

const SlidePage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Slide
    </Button>
  )

  return (
    <PageHeader title="All Slides" extra={[primaryAction]}>
      <Card>
        <SlideTableWrapper />
      </Card>
    </PageHeader>
  )
}

const SlideTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(SlideService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = SlideService.toPaginate(response)

  return (
    <>
      <SlideTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <SlideTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default SlidePage
